module.exports = "https://static.wanderu.com/static/media/gb.601fdab6.svg";